import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, Card, CardContent, Paper } from '@mui/material';
import { School, Group, Assessment, TrendingUp } from '@mui/icons-material';
import Layout from 'Component/Layouts/layout';
import { useNavigate } from 'react-router-dom';
import useCredentials from 'hooks/useCredentials';
import { useSelector, useDispatch } from 'react-redux';
import BatchInfoForm from 'Component/MultiStepTrainingForms/TrainingForm/BatchInfoForm';
import TraineeMapperDropBoxes from 'Component/MultiStepTrainingForms/TrainingForm/TraineeMapperDropBoxes';
import StepperComponent from 'Component/Stepper';
export const batchFormSteps = ['Batch Info', 'Select Trainees'];

export { default as AllTrainings } from './AllTrainings';
export { default as CreateBatch } from './CreateBatch';
export { default as ClusterView } from './ClusterView';
export { default as RegionsCircles } from './RegionsCircles';
export { default as Trainers } from './Trainers';
export { default as TrainingTypes } from './TrainingTypes';
export { default as CertificationLogs } from './CertificationLogs';
export { default as TrainingReports } from './TrainingReports';
export { default as TraineeApproval } from './TraineeApproval';
export { default as BatchApproval } from './BatchApproval';
export { default as UploadNomination } from './UploadNomination';
export { default as ClusterConfig } from './ClusterConfig';

const Training = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData: user } = useCredentials(); // Retrieve user from auth hook
  const isLearningSuperUser = user?.learningRoles?.includes('TRAINER_SUPER_ADMIN');
  const [isAdmin, setIsAdmin] = useState(null);
  const trainingFormDetail = useSelector((state) => state?.trainingSlice);
  const { step1Validated, emailConfig } = trainingFormDetail;
  const [selectAllClicked, setSelectAllClicked] = useState(false);

  const returnTitles = () => {
    const components = [];
    let title = 'Create Batch';

    // if (step1Validated) {
    //   components.push(
    //     <Button
    //       variant="contained"
    //       color="primary"
    //       onClick={() => {
    //         dispatch(createBatch());
    //         navigate("/training");
    //       }}
    //       disabled={!emailConfig || !emailConfig.steps.every(step => step.to.length > 0)}
    //     >
    //       Create Batch
    //     </Button>
    //   );
    // }

    return { title, components };
  };

  useEffect(() => {
    if (user) {
      setIsAdmin(user.role !== 'user');
    }
  }, [user]);

  return (
    <Layout>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          p: { xs: 2, md: 3 },
        }}
      >
        {/* Professional Header */}
        <Box
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            borderRadius: '16px',
            p: 3,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid #e2e8f0',
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            <Box>
              <Typography
                variant="h4"
                fontWeight="700"
                sx={{
                  color: '#1e293b',
                  mb: 0.5,
                  background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Training Management
              </Typography>
              <Typography variant="body1" sx={{ color: '#64748b', fontWeight: '400' }}>
                Create and manage training batches for your organization
              </Typography>
            </Box>
            <Box display="flex" gap={2} alignItems="center">
              {returnTitles().components.map((elem, index) => (
                <Box key={index}>{elem}</Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Quick Stats Cards */}
        <Box sx={{ display: 'flex', gap: 3, mb: 4, flexWrap: 'wrap' }}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid #e2e8f0',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              minWidth: 200,
              flex: 1,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                    color: 'white',
                    mr: 2,
                  }}
                >
                  <School />
                </Box>
                <Typography variant="h6" fontWeight="600" sx={{ color: '#1e293b' }}>
                  Training Types
                </Typography>
              </Box>
              <Typography variant="h4" fontWeight="700" sx={{ color: '#1e293b', mb: 1 }}>
                2
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b' }}>
                Induction & Collection
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid #e2e8f0',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              minWidth: 200,
              flex: 1,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    color: 'white',
                    mr: 2,
                  }}
                >
                  <Group />
                </Box>
                <Typography variant="h6" fontWeight="600" sx={{ color: '#1e293b' }}>
                  Batch Creation
                </Typography>
              </Box>
              <Typography variant="h4" fontWeight="700" sx={{ color: '#1e293b', mb: 1 }}>
                Active
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b' }}>
                Create new training batches
              </Typography>
            </CardContent>
          </Card>

          <Card
            sx={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '1px solid #e2e8f0',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              minWidth: 200,
              flex: 1,
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                    color: 'white',
                    mr: 2,
                  }}
                >
                  <Assessment />
                </Box>
                <Typography variant="h6" fontWeight="600" sx={{ color: '#1e293b' }}>
                  Progress
                </Typography>
              </Box>
              <Typography variant="h4" fontWeight="700" sx={{ color: '#1e293b', mb: 1 }}>
                {!step1Validated ? '1' : '2'}/2
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b' }}>
                Steps completed
              </Typography>
            </CardContent>
          </Card>
        </Box>

        {/* Form Section */}
        <Card
          sx={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            border: '1px solid #e2e8f0',
            borderRadius: '20px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            mb: 4,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <StepperComponent stepperCount={!step1Validated ? 1 : 2} propsSteps={batchFormSteps} />
            <Box
              sx={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '30px',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                mt: 3,
              }}
            >
              {!step1Validated ? <BatchInfoForm /> : <TraineeMapperDropBoxes />}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Layout>
  );
};

export default Training;
